<script>
    import NavBar from "../components/NavBar.svelte";
    import { collection, query, where, getDocs } from "firebase/firestore";
    import { db } from "../firebase";

    async function runQuerySnapshot() {
        const contactsRef = collection(db, "contacts");
        const contactsQuery = query(contactsRef, where("owner", "==", "fOOlT8Md7uWr4C1vpF7yR7eJKMX2"));
        const querySnapshot = await getDocs(contactsQuery);
        const data = querySnapshot.docs.map(doc => doc.data());
        return data;
    }

    let promise = runQuerySnapshot();

</script>

<div>
    <NavBar/>
    <div class="app-container">
        <div class="box">
            <label class="label">Opt-In Form</label>
            <div class="control">
                <input class="input" type="text" value="https://sms.jfv.one/#/form/nexgen" readonly>
            </div>
            <!-- <a class="button is-dark" href="#/contacts/add">Add Contact</a> -->
            <hr>
            <div class="columns mt-3">
                <div class="column">
                    <strong>#</strong>
                </div>
                <div class="column">
                    <strong>Name</strong>
                </div>
                <div class="column">
                    <strong>Number</strong>
                </div>
                <div class="column">
                    <strong>Status</strong>
                </div>
                <!-- <div class="column">
                    <strong>Action</strong>
                </div> -->
            </div>
            {#await promise}
                <p>Loading...</p>
            {:then list}

                {#each list as item, i}

                <div class="columns">
                    <div class="column">
                        {i + 1}
                    </div>
                    <div class="column">
                        {item.fullName}
                    </div>
                    <div class="column">
                        {item.phoneNumber}
                    </div>
                    <div class="column">
                        {#if item.doubleOptIn == false}
                            <span class="tag is-rounded is-warning">Waiting</span>
                        {/if}
                        {#if item.doubleOptIn == true}
                            <span class="tag is-rounded is-success">Opt-In</span>
                        {/if}
                    </div>
                    <!-- <div class="column">
                        <button>View</button>
                    </div> -->
                </div>

                {/each}

            {:catch error}
                <p>Sorry, there was an error loading in your contacts!</p>
            {/await}
        </div>
    </div>
</div>